import { useState, useEffect } from 'react';

export const useVersionCheck = () => {
  const [isVersionMismatch, setIsVersionMismatch] = useState(false);

  useEffect(() => {
    let mounted = true;

    const checkVersion = async () => {
      try {
        const response = await fetch('/version.json', {
          cache: 'no-store', // Ensure we get the latest version
        });

        if (!response.ok) {
          console.error('Failed to fetch version.json');
          return;
        }

        const data = await response.json();

        if (!mounted) return;

        const currentHash = data.version_hash;
        const storedHash = localStorage.getItem('app_version_hash');

        if (!storedHash) {
          // First load, store the hash
          localStorage.setItem('app_version_hash', currentHash);
        } else if (storedHash !== currentHash) {
          // Version mismatch
          setIsVersionMismatch(true);
        }
      } catch (error) {
        console.error('Error checking version:', error);
      }
    };

    // Check immediately on mount
    checkVersion();

    const onFocus = () => {
      checkVersion();
    };

    window.addEventListener('focus', onFocus);
    // Also check on visibility change (e.g. switching tabs)
    window.addEventListener('visibilitychange', onFocus);

    return () => {
      mounted = false;
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('visibilitychange', onFocus);
    };
  }, []);

  return { isVersionMismatch };
};
